import i18n from 'utils/translation/i18n'
import departmentsList from 'utils/departmentsList'
import rolesList from 'utils/rolesList'

export default {
   name_en: {
      name: i18n.t('full_name'),
      required: true,
      stateName: 'name_en',
      type: 'TextInput',
   },
   staff_number: {
      name: i18n.t('staff_number'),
      required: true,
      stateName: 'staff_number',
      type: 'TextInput',
   },
   department: {
      name: i18n.t('department'),
      required: true,
      stateName: 'department',
      type: 'Dropdown2',
      options: departmentsList
   },
   role: {
      name: i18n.t('role'),
      required: true,
      stateName: 'role',
      type: 'Dropdown2',
      options: rolesList
   },
   manager: {
      name: i18n.t('manager'),
      required: false,
      stateName: 'manager',
      type: 'Dropdown2',
      options: [],
      isClearable: true,
   },
   supervisor: {
      name: i18n.t('supervisor_in_order'),
      required: false,
      stateName: 'supervisor',
      type: 'Dropdown2',
      options: [],
      isClearable: true,
      isMulti: true,
   },
   email: {
      name: i18n.t('email'),
      required: true,
      stateName: 'email',
      type: 'TextInput',
      inputType: 'email',
   },
   password: {
      name: i18n.t('password'),
      required: true,
      stateName: 'password',
      type: 'TextInput',
      inputType: 'new-password',
   },
   confirmPassword: {
      name: i18n.t('confirm_password'),
      required: true,
      stateName: 'confirmPassword',
      type: 'TextInput',
      inputType: 'new-password',
   },
   permissons: {
      name: i18n.t('permissons'),
      required: false,
      stateName: 'permissons',
      type: 'Checkboxes',
      options: [{
            id: 'CanTakeAction',
            value: i18n.t('can_take_action'),
            checked: false,
         },
         {
            id: 'CanGenerateForm',
            value: i18n.t('can_generate_form'),
            checked: false,
         },
         {
            id: 'CanAddStaff',
            value: i18n.t('can_add_staff'),
            checked: false,
         },
         {
            id: 'CanSetPriority',
            value: i18n.t('can_set_priority'),
            checked: false,
         },
         {
            id: 'CanRedirectRequest',
            value: i18n.t('can_redirect_request'),
            checked: false,
         },
         {
            id: 'CanSeeAllTickets',
            value: i18n.t('can_see_all_tickets'),
            checked: false,
         },
         {
            id: 'CanCompleteRequest',
            value: i18n.t('can_complete_request'),
            checked: false,
         },
      ]
   }
}